<template>
  <div v-show="show_player_cards">
    <div class="row">
      <div class="col-md-12">
        <table class="table table-bordered table-condensed">
          <thead>
            <tr>
                <td class="center"><strong>Hoyo</strong></td>
                <td class="center"><strong>1</strong></td>
                <td class="center"><strong>2</strong></td>
                <td class="center"><strong>3</strong></td>
                <td class="center"><strong>4</strong></td>
                <td class="center"><strong>5</strong></td>
                <td class="center"><strong>6</strong></td>
                <td class="center"><strong>7</strong></td>
                <td class="center"><strong>8</strong></td>
                <td class="center"><strong>9</strong></td>
                <td class="center"><strong>1ªVta</strong></td>
                <td class="center"><strong>10</strong></td>
                <td class="center"><strong>11</strong></td>
                <td class="center"><strong>12</strong></td>
                <td class="center"><strong>13</strong></td>
                <td class="center"><strong>14</strong></td>
                <td class="center"><strong>15</strong></td>
                <td class="center"><strong>16</strong></td>
                <td class="center"><strong>17</strong></td>
                <td class="center"><strong>18</strong></td>
                <td class="center"><strong>2ªVta</strong></td>
                <td class="center"><strong>Total</strong></td>
                <td class="center"><strong>Editar</strong></td>
            </tr>
          <tr>
            <th><strong>Par</strong></th>
            <th v-for="hole_out in holes_out">
              {{ hole_out.par}}
            </th>
            <th></th>
            <th v-for="hole_in in holes_in">
              {{ hole_in.par}}
            </th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="card in player_cards | orderBy 'date.date'">
            <td><strong>R{{ $index +1 }}</strong></td>
            <td>{{card.h1}}</td>
            <td>{{card.h2}}</td>
            <td>{{card.h3}}</td>
            <td>{{card.h4}}</td>
            <td>{{card.h5}}</td>
            <td>{{card.h6}}</td>
            <td>{{card.h7}}</td>
            <td>{{card.h8}}</td>
            <td>{{card.h9}}</td>
            <td>{{ totalOut(card) }}</td>
            <td>{{card.h10}}</td>
            <td>{{card.h11}}</td>
            <td>{{card.h12}}</td>
            <td>{{card.h13}}</td>
            <td>{{card.h14}}</td>
            <td>{{card.h15}}</td>
            <td>{{card.h16}}</td>
            <td>{{card.h17}}</td>
            <td>{{card.h18}}</td>
            <td>{{ totalIn(card) }}</td>
            <td>{{ totalCard(card) }}</td>
            <td>
              <button type="button" class="btn btn-default" @click="editCard(card)">
                <span class="glyphicon glyphicon-edit"></span>
              </button>
            </td>
          </tr>
          </tbody>
          <tfoot>

          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<style>

</style>

<script>
  import {
    getPlayerCards,
    getShowPlayerCards,
    getHolesIn,
    getHolesOut
  } from '../vuex/getters'

  import * as actions from '../vuex/actions'

  export default {
    vuex: {
      getters: {
        player_cards: getPlayerCards,
        show_player_cards: getShowPlayerCards,
        holes_in: getHolesIn,
        holes_out: getHolesOut
      },
      actions: actions
    },
    props: {
      show_player_cards: {default: false}
    },
    data() {
      return {
        holes: [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8},
          {id: 9}, {id: 10}, {id: 11}, {id: 12}, {id: 13}, {id: 14}, {id: 15}, {id: 16}, {id: 17}, {id: 18}]
      }
    },
    methods: {
      totalOut(card) {
        let total = 0;
        for (let i = 1; i < 10; i++) {
          let value = parseInt(card['h' + i])
          if (value > 0) {
            total = parseInt(total + value);
          }
        }
        return total;
      },
      totalIn(card) {
        let total = 0;
        for (let i = 10; i < 19; i++) {
          let value = parseInt(card['h' + i])
          if (value > 0) {
            total = parseInt(total + value);
          }
        }
        return total;
      },
      totalCard(card) {
        return this.totalOut(card) + this.totalIn(card);
      },
      editCard(card) {
        this.setCard(card);
        this.setHoles(card);
        this.showCard(true);
      },
      setHoles(card) {
        let holes_out = [];
        let holes_in = [];
        this.holes_out.forEach((h) => {
          let hole = h;
          hole.value = parseInt(card[hole.id]);
          holes_out.push(hole);
        });
        this.holes_in.forEach((h) => {
          let hole = h;
          hole.value = parseInt(card[hole.id]);
          holes_in.push(hole);
        })
        this.setHolesIn(holes_in);
        this.setHolesOut(holes_out);
      },
    }
  }
</script>



/** WEBPACK FOOTER **
 ** CardEditor.vue?a846e0c4
 **/